import types from "../types";

// initial state
const state = {
  ids: [],
  entities: {},
};

const getContactBookings = (state) => state.ids.map((id) => state.entities[id]);

// getters
const getters = {
  [types.getters.contactBookings]: getContactBookings,
  [types.getters.contactBooking]: (state) => (contactID) =>
    state.entities[contactID],
};

// actions
const actions = {
  [types.actions.updateContactBookingField](
    { commit },
    { contactID, fieldName, value },
  ) {
    commit(types.mutations.updateContactBookingField, {
      contactID,
      fieldName,
      value,
    });
  },
};

// mutations
const mutations = {
  [types.mutations.setContactBookings](state, contactBookings) {
    state.ids = contactBookings.map(
      (contactBooking) => contactBooking.contactID,
    );
    state.entities = contactBookings
      .map((contactBooking) => {
        contactBooking.planningToDive =
          contactBooking.planningToDive === "true" ||
          contactBooking.planningToDive === true;
        contactBooking.needAWetsuit =
          contactBookings.needAWetsuit === "true" ||
          contactBooking.needAWetsuit === true;
        return contactBooking;
      })
      .reduce((accumulate, contactBooking) => {
        accumulate[contactBooking.contactID] = contactBooking;
        return accumulate;
      }, {});
  },
  [types.mutations.updateContactBookingField](
    state,
    { contactID, fieldName, value },
  ) {
    state.entities[contactID][fieldName] = value;
    state.entities[contactID].isDirty = true;
  },
  [types.mutations.resetContactBookingsDirtyFlag](state) {
    getContactBookings(state).forEach((entity) => (entity.isDirty = false));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/contactBooking.js